// Muestra «Cargando...», el error con un botón para reintentar o el contenido ya cargado.
export default function EstadoCarga({ loading, error, onRetry, children }) {
  if (error) return (
    <div role="alert" style={{ margin: 'var(--space-4) 0' }}>
      <p>No se pudieron cargar los datos: {error}</p>
      <button type="button" onClick={onRetry}>Reintentar</button>
    </div>
  );
  if (loading) return <h3>Cargando...</h3>;
  return children;
}
